module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-sidebar', {
    attrs: {
      "activeNavItem": "shipment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": 'Shipment Details',
      "path": "/shipment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.rfqErrorMessage) ? _c('h4', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.rfqErrorMessage))])], 1) : _vm._e(), _vm._v(" "), (!_vm.rfqErrorMessage) ? _c('div', [(_vm.assetsLoaded && (_vm.assetsDispatched || _vm.isAwardedAssignee)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card bg-white mb-3"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("\n                  Dispatch\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "asset_tractor"
    }
  }, [_vm._v("Tractor")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dispatchedTractorId),
      expression: "dispatchedTractorId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "asset_tractor",
      "name": "asset_tractor",
      "disabled": !_vm.assetsLoaded || _vm.assetsDispatched
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dispatchedTractorId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.tractors), function(tractor) {
    return _c('option', {
      domProps: {
        "value": tractor._id
      }
    }, [_vm._v(_vm._s(tractor.title))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "asset_trailer"
    }
  }, [_vm._v("Trailer")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dispatchedTrailerId),
      expression: "dispatchedTrailerId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "asset_trailer",
      "name": "asset_trailer",
      "disabled": !_vm.assetsLoaded || _vm.assetsDispatched
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dispatchedTrailerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.trailers), function(trailer) {
    return _c('option', {
      domProps: {
        "value": trailer._id
      }
    }, [_vm._v(_vm._s(trailer.title))])
  })], 2)]), _vm._v(" "), (_vm.dispatchError) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.dispatchError))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-wd",
    attrs: {
      "disabled": _vm.assetsDispatched
    },
    on: {
      "click": function($event) {
        return _vm.dispatchAssetsHandler()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-road"
  }), _vm._v(" " + _vm._s(_vm.assetsDispatched ? 'Dispatched' : 'Dispatch'))])])])])]) : _vm._e(), _vm._v(" "), (_vm.showDispatchSummary) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card bg-white mb-3"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("\n                  Summary\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Requested Pick Up Date")]), _c('br'), _vm._v(_vm._s(_vm.shipickupdate))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-md-3"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Pick Up Date")]), _c('br'), _vm._v(_vm._s(_vm.actualPickupTime) + "\n                          "), (_vm.actualPickupTime && _vm.manualPickupTime) ? [_c('br'), _vm._v("(set manually)")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3"
  }, [(!_vm.actualPickupTime) ? _c('button', {
    staticClass: "btn btn-success btn-wd btn-sm",
    on: {
      "click": _vm.showPickupDateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Set Pick Up Date\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Carbon Emission Total")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.carbonEmissionError && _vm.carbonEmissions > 0) ? _c('span', [_vm._v(_vm._s(_vm.carbonEmissions) + " kg of CO2")]) : _vm._e(), _vm._v(" "), (_vm.carbonEmissionError) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.carbonEmissionError))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Requested Delivery")]), _c('br'), _vm._v(_vm._s(_vm.condeliverydate))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-md-3"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Delivery")]), _c('br'), _vm._v(_vm._s(_vm.actualDeliveryTime) + "\n                          "), (_vm.actualDeliveryTime && _vm.manualDeliveryTime) ? [_c('br'), _vm._v("(set manually)")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3"
  }, [(!_vm.actualDeliveryTime) ? _c('button', {
    staticClass: "btn btn-success btn-wd btn-sm",
    on: {
      "click": _vm.showDeliveryDateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Set Delivery Date")]) : _vm._e()])])])]), _vm._v(" "), (_vm.showShipped && _vm.assetsDispatched) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-wd",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.shipped()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" Shipped")])])]) : _vm._e(), _vm._v(" "), (!_vm.carbonEmissionError && _vm.carbonEmissions > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('ShippingLvls', {
    attrs: {
      "readOnly": true,
      "root": {
        components: _vm.detailrows
      },
      "showCarbon": true
    }
  })], 1)]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('UploadDocument', {
    attrs: {
      "showGenerate": true,
      "documents": _vm.documents,
      "rfq": _vm.rfq,
      "rfqId": _vm.rfqIdOnly
    },
    on: {
      "fileUploaded": _vm.saveDocumentToRFQ,
      "deleteUploadedDocument": _vm.deleteDocument
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("RFQ Customer Details")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.rfqIdOnly))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-3 border-right"
  }, [_c('h5', [_vm._v("Customer")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Company / Name")]), _c('br'), _vm._v(_vm._s(_vm.cuscompany))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Address")]), _c('br'), _vm._v(_vm._s(_vm.cusaddress) + ", " + _vm._s(_vm.cuscity) + ", " + _vm._s(_vm.cusprovince)), _c('br'), _vm._v(_vm._s(_vm.cuspostal)), _c('br'), _vm._v(_vm._s(_vm.cuscountry))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Terms")]), _c('br'), _vm._v(_vm._s(_vm.custerms))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Due Date")]), _c('br'), _vm._v(_vm._s(_vm.cusduedate))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("PO #")]), _c('br'), _vm._v(_vm._s(_vm.cuspo))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Sales #")]), _c('br'), _vm._v(_vm._s(_vm.cussales))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Transfer Order #")]), _c('br'), _vm._v(_vm._s(_vm.custranferorder))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-3 border-right"
  }, [_c('h5', [_vm._v("Shipper")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Company / Name")]), _c('br'), _vm._v(_vm._s(_vm.shicompany))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("PO #")]), _c('br'), _vm._v(_vm._s(_vm.shipo))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Release #")]), _c('br'), _vm._v(_vm._s(_vm.shirelease))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Address")]), _c('br'), _vm._v(_vm._s(_vm.shiaddress) + ", " + _vm._s(_vm.shicity) + ", " + _vm._s(_vm.shiprovince)), _c('br'), _vm._v(_vm._s(_vm.shipostal)), _c('br'), _vm._v(_vm._s(_vm.shicountry))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Appointment")]), _c('br'), _vm._v(_vm._s(_vm.shiappointment))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Liftgate")]), _c('br'), _vm._v(_vm._s(_vm.shiliftgate))])])]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Requested Pick Up Date")]), _c('br'), _vm._v(_vm._s(_vm.shipickupdate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-3 border-right"
  }, [_c('h5', [_vm._v("Consignee")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Company / Name")]), _c('br'), _vm._v(_vm._s(_vm.conname))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("PO #")]), _c('br'), _vm._v(_vm._s(_vm.conpo))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Address")]), _c('br'), _vm._v(_vm._s(_vm.conaddress) + ", " + _vm._s(_vm.concity) + ", " + _vm._s(_vm.conprovince)), _c('br'), _vm._v(_vm._s(_vm.conpostal)), _c('br'), _vm._v(_vm._s(_vm.concountry))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Appointment")]), _c('br'), _vm._v(_vm._s(_vm.conappointment))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Liftgate")]), _c('br'), _vm._v(_vm._s(_vm.conliftgate))])])]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Requested Delivery")]), _c('br'), _vm._v(_vm._s(_vm.condeliverydate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-3"
  }, [_c('h5', [_vm._v("Truck")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Trailer Type")]), _c('br'), _vm._v(_vm._s(_vm.trtrailertype))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Suspension Type")]), _c('br'), _vm._v(_vm._s(_vm.trsuspensiontype))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Temperature Control")]), _c('br'), _vm._v(_vm._s(_vm.trtempcontrol))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("COD")]), _c('br'), _vm._v(_vm._s(_vm.trcod))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Driver Assist")]), _c('br'), _vm._v(_vm._s(_vm.trdriverassist))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Mode")]), _c('br'), _vm._v(_vm._s(_vm.trmode))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Service")]), _c('br'), _vm._v(_vm._s(_vm.trservice))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Dunnage Required")]), _c('br'), _vm._v(_vm._s(_vm.trdunnagerequired))])])]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Special Instructions")]), _c('br'), _vm._v(_vm._s(_vm.trspecialinstructions))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-borderless"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center squeeze"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "min-width": "320px",
      "max-width": "320px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Description / Lot")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Stackable")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Length " + _vm._s(_vm.suunitlength))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Width " + _vm._s(_vm.suunitlength))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Height " + _vm._s(_vm.suunitlength))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Weight " + _vm._s(_vm.suunitweight))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Hazard")]), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "min-width": "120px",
      "max-width": "120px"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('th', {
    staticClass: "text-center squeeze"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.detailrows), function(row, shipIndex) {
    return [_c('TertiaryRow', {
      key: 'tertiary_' + shipIndex,
      attrs: {
        "row": row,
        "shipIndex": shipIndex,
        "readOnly": true
      },
      on: {
        "removeRow": null,
        "cloneRow": null
      }
    })]
  })], 2)])])])])])]), _vm._v(" "), (_vm.detailrows.length > 0) ? _c('ShippingSummary', {
    ref: "summary",
    attrs: {
      "rfq": _vm.rfq,
      "rows": _vm.detailrows,
      "density": _vm.density,
      "densityClass": _vm.densityclass,
      "totalWeight": _vm.totalWeight,
      "totalWeightKg": _vm.totalWeightKg
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(2)], 1) : _vm._e()]), _vm._v(" "), _c('v-footer')], 1), _vm._v(" "), _c('v-pickup-date-modal'), _vm._v(" "), _c('v-delivery-date-modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Detailed Carbon Emission")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Shipping Units")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-success btn-wd",
    attrs: {
      "href": "#/shipment/view"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74b91e62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shipment/ShipmentDetail.vue
// module id = 739
// module chunks = 0